import { useSelector } from 'react-redux'

// Selectors
import { licenseInfoSelector } from 'selectors'

// Types
import { State, UserSong, UserSongRevenueReport } from 'types'

// Utils
import { priceString } from 'components/base/price'

import styles from './totals.css'

type ItemProps = {
  title: string
  value: string
}

const Item = ({ title, value }: ItemProps): JSX.Element => (
  <li className={styles.item}>
    <p className={styles.title}>{title}:</p>
    <span className={styles.value}>{value}</span>
  </li>
)

type TotalsProps = {
  userSongRevenueReports: Array<UserSongRevenueReport>
  userSong: UserSong
}

const Totals = ({ userSongRevenueReports, userSong }: TotalsProps): JSX.Element => {
  const sample = userSong.samples[0]
  const licenseInfo = useSelector<State>(s => licenseInfoSelector(s, sample)) as { sharePercentage: number }
  const sortedRevenueReports = userSongRevenueReports.sort(
    ({ period: { reporting_close: reportingCloseA } }, { period: { reporting_close: reportingCloseB } }) =>
      new Date(reportingCloseB).getTime() - new Date(reportingCloseA).getTime(),
  )
  const totalRevenue = userSongRevenueReports.reduce((agg, report) => agg + report.total_amount_reported, 0)
  const totalShare = userSongRevenueReports.reduce((agg, report) => agg + report.total_amount, 0)
  const { currency } = sortedRevenueReports[0]

  const items = [
    { title: 'Total revenue', value: priceString(totalRevenue, currency) },
    { title: 'Revenue share', value: `${licenseInfo?.sharePercentage}%` },
    { title: 'Total share', value: priceString(totalShare, currency) },
  ]
  if (userSong.samples[0].recoupable_total > 0) {
    items.push({
      title: 'Remaining recoup',
      value: priceString(userSong.samples[0].recoupable_remaining || 0, currency),
    })
  }
  return (
    <ul className={styles.container}>
      {items.map(({ title, value }, index) => (
        <Item title={title} value={value} key={String(index)} />
      ))}
    </ul>
  )
}

export default Totals
